import AboutPage from './aboutPage';

export default AboutPage;
